import React, { useEffect, useState } from 'react'
import { CreateMessage } from '../actions/Messages/MessageAction';
import { item_church } from '../dataApi';
import { LoadAllContact } from '../actions/ActivitesPages/ManagerPageAction';
import LocationChurch from '../components/LocationChurch';
import { toast } from "react-toastify";
import { getDataFromFile } from '../actions/SearchAction';
import { Localvalue } from '../nametitle/localValue';

const ContactPage = () => {
    const [name, setname] = useState('');
    const [email, setemail] = useState('');
    const [subject, setsubject] = useState("");
    const [telephone, settelephone] = useState('');
    const [content, setcontent] = useState("");







    const [id, setid] = useState();

    const [coverPicture, setcoverPicture] = useState();
    const [logo, setlogo] = useState();
    const [nameChurch, setnameChurch] = useState();
    const [emailChurch, setemailChurch] = useState();
    const [telephone1, settelephone1] = useState();
    const [telephone2, settelephone2] = useState();
    const [telephone3, settelephone3] = useState();

    const [facebook, setfacebook] = useState();
    const [youtube, setyoutube] = useState();
    const [instagram, setinstagram] = useState();



    const [Loading, setLoading] = useState();

    useEffect(() => {
        const object = getDataFromFile(Localvalue.activitePageData);
        setlogo(object && object.contact && object.contact.activite1 && object.contact.activite1.logo ? object.contact.activite1.logo : "");
        setname(object && object.contact && object.contact.activite1 && object.contact.activite1.name ? object.contact.activite1.name : "");
        setcoverPicture(object && object.contact && object.contact.activite1 && object.contact.activite1.coverPicture ? object.contact.activite1.coverPicture : "");
        // ***************************************************     Activté 3
        setemail(object && object.contact && object.contact.activite2 && object.contact.activite2.email ? object.contact.activite2.email : "");
        settelephone1(object && object.contact && object.contact.activite2 && object.contact.activite2.telephone1 ? object.contact.activite2.telephone1 : "");
        settelephone2(object && object.contact && object.contact.activite2 && object.contact.activite2.telephone2 ? object.contact.activite2.telephone2 : "");
        settelephone3(object && object.contact && object.contact.activite2 && object.contact.activite2.telephone3 ? object.contact.activite2.telephone3 : "");
        // ***************************************************     Activté 3
        setfacebook(object && object.contact && object.contact.activite3 && object.contact.activite3.facebook ? object.contact.activite3.facebook : "");
        setyoutube(object && object.contact && object.contact.activite3 && object.contact.activite3.youtube ? object.contact.activite3.youtube : "");
        setinstagram(object && object.contact && object.contact.activite3 && object.contact.activite3.instagram ? object.contact.activite3.instagram : "");
        LoadAllContact(setid, setlogo, setnameChurch, setcoverPicture,
            setemailChurch, settelephone1, settelephone2, settelephone3,
            setfacebook, setyoutube, setinstagram)
    }, []);

    return (
        <div>
            <div className="container-fluid pt-5">
                <div className="container">
                    <div className="border-center border-3 rounded-xl border-primary ps-5 mb-5" style={{ maxWidth: "600px" }}>
                        <h6 className="text-primary text-uppercase"></h6>
                        <h1 className="display-6 text-uppercase mb-0 translatable">Nous contacter</h1>
                    </div>
                    <div className="row g-5">
                        <div className="col-lg-7">
                            <form
                                onSubmit={(e => {
                                    e.preventDefault();
                                    CreateMessage(name, email, subject, telephone, content, toast);
                                })}>
                                <div className="row g-3">
                                    <div className="col-12">
                                        <input type="text" value={name} onChange={(e) => { setname(e.target.value) }} className="form-control bg-light border-0 px-4 rounded-lg translatable" placeholder="Votre Nom" style={{ height: "55px" }} />
                                    </div>
                                    <div className="col-12">
                                        <input type="email" value={email} onChange={(e) => { setemail(e.target.value) }} className="form-control bg-light border-0 px-4 rounded-lg translatable" placeholder="votre email" style={{ height: "55px" }} />
                                    </div>
                                    <div className="col-12">
                                        <input type="number" value={telephone} onChange={(e) => { settelephone(e.target.value) }} className="form-control bg-light border-0 px-4 rounded-lg translatable" placeholder="téléphone" style={{ height: "55px" }} />
                                    </div>
                                    <div className="col-12">
                                        <input type="text" value={subject} onChange={(e) => { setsubject(e.target.value) }} className="form-control bg-light border-0 px-4 rounded-lg translatable" placeholder="Sujet de votre" style={{ height: "55px" }} />
                                    </div>
                                    <div className="col-12">
                                        <textarea value={content} onChange={(e) => { setcontent(e.target.value) }} className="form-control bg-light border-0 px-4 py-3 rounded-lg translatable" rows="8" placeholder="Ecrire plus ici ..."></textarea>
                                    </div>
                                    <div className="col-12">
                                        <button className="btn btn-primary w-100 bg-lime-700 py-3  rounded-lg translatable" type="submit">Envoyer un message</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="col-lg-5">
                            <div className="bg-light mb-5 p-5 rounded-2xl">
                                <div className="d-flex align-items-center mb-2">
                                    <i className="bi bi-geo-alt fs-1 text-primary me-3"></i>
                                    <div className="text-start">
                                        <h6 className="text-uppercase mb-1 translatable">Lieux</h6>
                                        <p className="mb-2 text-gray-700 flex space-x-2">
                                            <img
                                                src="https://img.freepik.com/vecteurs-premium/drapeau-cote-ivoire-vecteur_671352-101.jpg?w=1060"
                                                className="h-5 w-5 rounded-lg"
                                            />
                                            <span className="translatable">Côte d{"'"}ivoire , Deux Plateaux , Careffour Marché</span>
                                        </p>
                                        <p className="mb-2 text-gray-700 flex space-x-2">
                                            <img
                                                src="https://img.freepik.com/vecteurs-premium/drapeau-du-ghana-vecteur_671352-85.jpg?w=1060"
                                                className="h-5 w-5 rounded-lg"
                                            />
                                            <span className="translatable">Ghana</span>
                                        </p>
                                        <p className="mb-2 text-gray-700 flex space-x-2">
                                            <img
                                                src="https://img.freepik.com/vecteurs-libre/illustration-du-drapeau-france_53876-27099.jpg?w=1060&t=st=1693326599~exp=1693327199~hmac=2d48b3ebab5a4e1caee14c0789c6f8719974fca67902908b833d89dcf94591a3"
                                                className="h-5 w-5 rounded-lg"
                                            />
                                            <span className="translatable">France</span>
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center mb-2">
                                    <i className="bi bi-envelope-open fs-1 text-primary me-3"></i>
                                    <div className="text-start">
                                        <h6 className="text-uppercase mb-1 translatable">Email </h6>
                                        <div>
                                            <a href={`mailto:${emailChurch}`}><span>{emailChurch}</span></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center mb-4">
                                    <i className="bi bi-phone-vibrate fs-1 text-primary me-3"></i>
                                    <div className="text-start">
                                        <h6 className="text-uppercase mb-1 translatable">Telephone</h6>

                                        <div>
                                            <a href={`tel:${telephone1}`}><span>{telephone1}</span></a>
                                        </div>
                                        <div>
                                            <a href={`tel:${telephone2}`}><span>{telephone2}</span></a>
                                        </div>
                                        <div>
                                            <a href={`tel:${telephone3}`}><span>{telephone3}</span></a>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>



                    <LocationChurch />



                </div>
            </div>

        </div>
    )
}

export default ContactPage